
$(".menu-item-has-children > a").click(function (e) {
  e.preventDefault()
     $(this).parents('li').toggleClass('open')
})

$('.mobile-arr').click(function () {
  $(this).prev().toggleClass('open');
  $(this).toggleClass('open');
})

$('.mobile-trigger').click(function () {
   $('#site-navigation').toggleClass('open-menu');
   $('.hamburger').toggleClass('is-active');
})



// WEBPACK FOOTER //
// ./scripts/components/header.js